var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("system.assign_role"),
            "close-on-click-modal": false,
            visible: _vm.dialogUserVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUserVisible = $event
            },
            close: _vm.initData,
          },
        },
        [
          _c("div", { staticClass: "header-line" }),
          _c("div", { staticStyle: { margin: "20px 0" } }, [
            _c("div", { staticClass: "assign-role-dec" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("system.role_details")))]),
            ]),
            _c(
              "div",
              { staticClass: "assign-role-form" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "200px",
                      rules: _vm.rules,
                      "label-position": "top",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "200px",
                          display: "inline-block",
                          "margin-right": "20px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("system.role_name") + ":",
                              prop: "role_id",
                            },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.masterAccFlag },
                                on: { change: _vm.handleChangeRole },
                                model: {
                                  value: _vm.form.role_id,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "role_id", $$v)
                                  },
                                  expression: "form.role_id",
                                },
                              },
                              _vm._l(_vm.roleList, function (role) {
                                return _c(
                                  "div",
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        key: role.id,
                                        staticStyle: {
                                          "margin-bottom": "10px",
                                        },
                                        attrs: { label: role.id },
                                      },
                                      [_vm._v(_vm._s(role.role_name))]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "500px",
                          display: "inline-block",
                          "vertical-align": "top",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("system.authority") + ":",
                              prop: "role_auths",
                            },
                          },
                          [
                            _c("SystemMchMenu", {
                              attrs: {
                                "menu-list": _vm.menuList,
                                "auth-list": _vm.checkAuths,
                                "modal-flag": 3,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogUserVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.listLoading },
                  on: {
                    click: function ($event) {
                      return _vm.submitAssignRole("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.submit")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }